import createIcon from '../../createIcon';

/**
 * @component @name Security
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMUwzIDVWMTFDMyAxNi41NSA2Ljg0IDIxLjc0IDEyIDIzQzE3LjE2IDIxLjc0IDIxIDE2LjU1IDIxIDExVjVMMTIgMVpNMTIgMTEuOTlIMTlDMTguNDcgMTYuMTEgMTUuNzIgMTkuNzggMTIgMjAuOTNWMTJINVY2LjNMMTIgMy4xOVYxMS45OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Security = createIcon('Security', [
  [
    'path',
    {
      d: 'M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.99H19C18.47 16.11 15.72 19.78 12 20.93V12H5V6.3L12 3.19V11.99Z',
      key: 'pk4l6y',
    },
  ],
]);

export default Security;
